import React, { Component } from 'react';
import cloudinary from 'cloudinary-core';
import DemoImage from './DemoImage';
import ZoomImage from './ZoomImage';


export default class EcommercePanel extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { effect: null };
    this.colorSelectionHandler = this.colorSelectionHandler.bind(this);
    this.cl = props.cl || cloudinary.Cloudinary.new();
    this.cl.fromDocument();
  }

  colorSelectionHandler(color) {
    let handler = (e) => {
      e.preventDefault();
      this.setState({ effect: color ? color + ':60' : null });
    };
    handler.bind(this);
    return handler;
  }


  render() {
    if (this.props.publicId) {
      const largeImageTrans = { crop: 'fill', aspect_ratio: '245:162', effect: this.state.effect, fetch_format: 'jpg' };
      const smallImageTrans = {...largeImageTrans, width: 490 };
      const largeImageSrc = this.cl.url(this.props.publicId, largeImageTrans);
      const smallImageSrc = this.cl.url(this.props.publicId, smallImageTrans);

      const header = (
        <header className="ecomm-title-head">
          <div className="top-wrap">
            <h2>Product name</h2>
            <span className="btn-yellow">Add to cart</span>
          </div>
          <p>Note: Signature required upon delivery due to high value of this item.<strong className="highlight">In Stock.</strong></p>
        </header>
      );

      return (
        <section className="website">
          <header className="sub-heading white">
            <h2>E-commerce sites</h2>
            <p>It's always a challenge to present your products with high quality without compromising page loading time, to get the best user experience, and ultimately conversion. Cloudinary handles this fine balance for you.</p>
          </header>
          <div className="web-ecommerce">
            <div className="browser-head">
              <ul className="list-inline bullets">
                <li>bullet</li>
                <li>bullet</li>
                <li>bullet</li>
              </ul>
            </div>
            <header className="header">
              <div className="top">
                <strong className="logo">E-SHOP</strong>
                <div className="search-box">
                  <i className="input">Search...</i>
                  <span className="icon-magnify" />
                  <span className="option">All Categories</span>
                </div>
              </div>
              <ul className="nav">
                <li className="active">All Category</li>
                <li>Best Sellers</li>
                <li>Fashion</li>
                <li>Electronics</li>
                <li>Collectibles &amp; Art</li>
                <li>Home &amp; Garden</li>
                <li className="hidden-sm hidden-xs">Sporting Goods</li>
                <li className="hidden-md hidden-sm hidden-xs">Motors</li>
                <li className="hidden-md hidden-sm hidden-xs">Daily Deals</li>
              </ul>
            </header>
            <div className="main">
              <div className="col-left">
                <div className="e-commerce-left-col-title">
                  {header}
                </div>
                <ZoomImage width={490} height={324} smallImageSrc={smallImageSrc} largeImageSrc={largeImageSrc} className="img"/>
                <ul className="img-list list-inline ecommerce-image-list">
                  <li>
                    <DemoImage {...this.props} transformation={[{ crop: 'fill', aspect_ratio: '120:77', width: 'auto', gravity: 'faces' }, { overlay: 'text:Arial_24px_bold:$14.99', color: 'yellow' }, { effect: 'shadow', color: 'black', flags: 'layer_apply', gravity: 'north_west', x: 10, y: 10 }, { dpr: 'auto' }]} className="img" format="jpg">
                      <ul><li>Crop and resize the image to the relevant size</li><li>Focus on auto-detected faces</li><li>Add a dynamic text overlay and place it in the north-west corner</li></ul>
                    </DemoImage>
                  </li>
                  <li>
                    <DemoImage {...this.props} transformation={{ dpr: 'auto', crop: 'fill', gravity: 'auto', aspect_ratio: '101:77', width: 'auto' }} className="img" format="jpg">
                      <ul><li>Crop and resize the image to fit graphic design</li><li>Focus on the auto-detected area of interest</li></ul>
                    </DemoImage>
                  </li>
                  <li>
                    <DemoImage {...this.props} transformation={{ dpr: 'auto', crop: 'fill', gravity: 'faces', aspect_ratio: '158:77', width: 'auto', effect: 'sharpen:300' }} className="img" format="jpg">
                      <ul><li>Crop and resize the image to a different aspect ratio</li><li>Focus on auto-detected faces</li><li>Sharpen the image</li></ul>
                    </DemoImage>
                  </li>
                  <li>
                    <DemoImage {...this.props} transformation={{ dpr: 'auto', crop: 'thumb', gravity: 'auto', aspect_ratio: '75:77', width: 'auto' }} className="img" format="jpg">
                      <p>Create a thumbnail dynamically.</p><ul><li>Focus on the auto-detected area of interest</li><li>Crop and resize the image</li></ul>
                    </DemoImage>
                  </li>
                </ul>
              </div>
              <div className="col-right">
                <div className="e-commerce-right-col-title">
                  {header}
                </div>
                <div className="color-select">
                  <h3>Select color</h3>
                  <ul className="list-inline img-list">
                    <li onClick={this.colorSelectionHandler(null)}>
                      <DemoImage {...this.props} transformation={{ dpr: 'auto', crop: 'fill', aspect_ratio: '100:67', width: 'auto' }} className="img clickable-img" format="jpg">
                        <p>Resize and crop the image to optimally fit the size of the product gallery image.</p>
                      </DemoImage>
                    </li>
                    <li onClick={this.colorSelectionHandler('red')}>
                      <DemoImage {...this.props} transformation={{ dpr: 'auto', crop: 'fill', aspect_ratio: '100:67', width: 'auto', effect: 'red:60' }} className="img clickable-img" format="jpg">
                        <ul><li>Crop the image to the size of the product gallery image</li><li>Increase the intensity of the red channel</li></ul>
                      </DemoImage>
                    </li>
                    <li onClick={this.colorSelectionHandler('green')}>
                      <DemoImage {...this.props} transformation={{ dpr: 'auto', crop: 'fill', aspect_ratio: '100:67', width: 'auto', effect: 'green:60' }} className="img clickable-img" format="jpg">
                        <ul><li>Crop the image to the size of the product gallery image</li><li>Increase the intensity of the green channel</li></ul>
                      </DemoImage>
                    </li>
                    <li onClick={this.colorSelectionHandler('blue')}>
                      <DemoImage {...this.props} transformation={{ dpr: 'auto', crop: 'fill', aspect_ratio: '100:67', width: 'auto', effect: 'blue:60' }} className="img clickable-img" format="jpg">
                        <ul><li>Crop the image to the size of the product gallery image</li><li>Increase the intensity of the blue channel</li></ul>
                      </DemoImage>
                    </li>
                  </ul>
                </div>
                <article className="article">
                  <h3>Product Description</h3>
                  <p>Easily create product galleries for browsing various product images or colors using thumbnails, allowing users to zoom in on every detail.</p>
                </article>
                <article className="article">
                  <h3>Shipping</h3>
                  <p>Item location: Sunnyvale, California, US</p>
                  <p>Shipping to: US, Canada, United Kingdom, China, Mexico, Germany</p>
                </article>
              </div>
            </div>
          </div>
        </section>
      );
    } else {
      return (<div/>);
    }
  }
}




/** WEBPACK FOOTER **
 ** ./src/js/components/EcommercePanel.js
 **/